import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { rePosts, dl } from "@/lib/docstate";

const fmtDate = (s) => { try { return new Date(s).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }); } catch { return ""; } };

export default function DocstateBlog() {
  const [data, setData] = useState(null);
  useEffect(() => { window.scrollTo(0, 0); rePosts({ limit: 24 }).then(setData).catch(() => setData({ items: [] })); }, []);

  return (
    <div className="ds-bg min-h-screen pt-16" data-testid="docstate-blog">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-8 lg:px-12">
        <p className="ds-eyebrow">Insights</p>
        <h1 className="ds-display mt-2 text-4xl font-medium text-white sm:text-5xl">The Docstate Journal</h1>
        <p className="mt-4 max-w-2xl text-lg font-light text-[#C9BBB2]">Market intelligence, buying guides and stories from Dubai's property world.</p>

        {!data ? (
          <div className="mt-16 flex justify-center"><Loader2 className="h-8 w-8 animate-spin text-[#C9A24B]" /></div>
        ) : data.items.length ? (
          <div className="mt-12 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {data.items.map((p, i) => (
              <motion.div key={p.id} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}>
                <Link to={dl(`/blog/${p.slug}`)} className="group block" data-testid={`post-card-${p.slug}`}>
                  <div className="ds-card overflow-hidden">
                    <div className="h-52 overflow-hidden">
                      <img src={p.cover} alt={p.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                    </div>
                    <div className="p-6">
                      {p.category && <span className="ds-eyebrow">{p.category}</span>}
                      <h2 className="ds-display mt-2 text-xl text-white transition-colors group-hover:text-[#F3E5AB]">{p.title}</h2>
                      <p className="mt-2 line-clamp-2 text-sm font-light text-[#9D8D83]">{p.excerpt}</p>
                      <div className="mt-4 flex items-center justify-between text-xs text-[#6E635B]">
                        <span>{fmtDate(p.created_at)}</span>
                        <span className="inline-flex items-center gap-1 text-[#C9A24B]">Read <ArrowRight className="h-3 w-3" /></span>
                      </div>
                    </div>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        ) : (
          <p className="mt-12 text-sm font-light text-[#9D8D83]">New articles are on the way.</p>
        )}
      </div>
    </div>
  );
}
